// removed by extract-text-webpack-plugin
module.exports = {"QrCode":"QrCode","QrCodeCanvas":"QrCodeCanvas","QrCodeImage":"QrCodeImage","downloadBtn":"downloadBtn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/QrCode/QrCode.scss
// module id = D8Gs
// module chunks = 0